import { render, staticRenderFns } from "./VentAlarmSettings.vue?vue&type=template&id=a86ec1c4&scoped=true&"
import script from "./VentAlarmSettings.vue?vue&type=script&lang=ts&"
export * from "./VentAlarmSettings.vue?vue&type=script&lang=ts&"
import style0 from "./VentAlarmSettings.vue?vue&type=style&index=0&id=a86ec1c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a86ec1c4",
  null
  
)

export default component.exports